module.exports = __webpack_public_path__ + "img/img-d47270.jpg";